
import "./Dice.scss";
import classNames from 'classnames';
import { useEffect } from "react";
import store from "../../store/store";
import { diceActions } from "./diceSlice";

export default function Dice(props: { value: number | null, isLoading: boolean, isActive: boolean }) {
  const { value, isLoading, isActive } = props;
  const gameState = store.getState().game;

  useEffect(() => {
    if (isLoading) {
      setTimeout(() => {
        store.dispatch(diceActions.stopLoading())
      }, 1500);
    }
  }, [isLoading]);

  function sendDice() {
    if (!gameState.isConnected || isLoading || !isActive) {
      return;
    }

    if (gameState.player) {
      store.dispatch(diceActions.sendDice({ gameId: gameState.gameId, playerId: gameState.player.data.playerId }));
    }
  }

  const classes = classNames({
    'dice': true,
    'dice_loading': isLoading,
    'dice_disabled': !gameState.isConnected
  });

  const ONE =   !isLoading && value === 1;
  const TWO =   !isLoading && value === 2;
  const THREE = !isLoading && value === 3;
  const FOUR =  !isLoading && value === 4;
  const FIVE =  !isLoading && value === 5;
  const SIX =   !isLoading && value === 6;

  return (
    <div className={classes} onClick={() => sendDice()}>
      {ONE &&
        <div className="dice-side side-one">
          <div className="dot one-1"></div>
        </div>
      }
      {TWO &&
        <div className="dice-side side-two">
          <div className="dot two-1"></div>
          <div className="dot two-2"></div>
        </div>
      }
      {THREE &&
        <div className="dice-side side-three">
          <div className="dot three-1"></div>
          <div className="dot three-2"></div>
          <div className="dot three-3"></div>
        </div>
      }
      {(FOUR || isLoading) &&
        <div className="dice-side side-four">
          <div className="dot four-1"></div>
          <div className="dot four-2"></div>
          <div className="dot four-3"></div>
          <div className="dot four-4"></div>
        </div>
      }
      {FIVE &&
        <div className="dice-side side-five">
          <div className="dot five-1"></div>
          <div className="dot five-2"></div>
          <div className="dot five-3"></div>
          <div className="dot five-4"></div>
          <div className="dot five-5"></div>
        </div>
      }
      {SIX &&
        <div className="dice-side side-six">
          <div className="dot six-1"></div>
          <div className="dot six-2"></div>
          <div className="dot six-3"></div>
          <div className="dot six-4"></div>
          <div className="dot six-5"></div>
          <div className="dot six-6"></div>
        </div>
      }
    </div>
  )
}
